import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { deepmerge } from "../deepmerge";
import accordionDe from "./translations/de-DE/accordion.json";
import errorPagesDe from "./translations/de-DE/errorPages.json";
import footerDe from "./translations/de-DE/footer.json";
import sidebarDe from "./translations/de-DE/sidebar.json";
import videoCardDe from "./translations/de-DE/videoCard.json";
import accordionEn from "./translations/en-GB/accordion.json";
import errorPagesEn from "./translations/en-GB/errorPages.json";
import footerEn from "./translations/en-GB/footer.json";
import sidebarEn from "./translations/en-GB/sidebar.json";
import videoCardEn from "./translations/en-GB/videoCard.json";
export const TRANSLATION_RESOURCES = {
    "en-GB": {
        footer: footerEn,
        errorPages: errorPagesEn,
        accordion: accordionEn,
        videoCard: videoCardEn,
        sidebar: sidebarEn,
    },
    "de-DE": {
        footer: footerDe,
        errorPages: errorPagesDe,
        accordion: accordionDe,
        videoCard: videoCardDe,
        sidebar: sidebarDe,
    },
};
export const generatedNamespaces = Object.keys(TRANSLATION_RESOURCES["en-GB"]);
// https://www.i18next.com/overview/configuration-options
export const defaultI18nOptions = {
    fallbackLng: "en-GB",
    supportedLngs: ["en-GB", "de-DE"],
    load: "currentOnly", // language codes to lookup
    resources: TRANSLATION_RESOURCES,
    nsSeparator: ":",
    keySeparator: ".",
    ns: generatedNamespaces,
    debug: process.env.NODE_ENV === "development" ? true : false,
    detection: {
        // order and from where user language should be detected
        order: ["localStorage", "cookie", "querystring", "path", "subdomain", "navigator", "htmlTag"],
        // keys or params to lookup language from(Set to KeyCloak's locale so that it will also reflect login page)
        lookupCookie: "KEYCLOAK_LOCALE",
    },
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    initImmediate: false,
    react: {
        bindI18n: "languageChanged editorSaved",
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ["br", "strong", "b", "i", "p"],
    },
};
export function setupI18n(i18nConfig, plugins = []) {
    const initOptions = deepmerge(defaultI18nOptions, i18nConfig);
    const sharedI18next = i18next.createInstance();
    sharedI18next.use(LanguageDetector).use(initReactI18next);
    plugins.forEach((plugin) => {
        sharedI18next.use(plugin);
    });
    void sharedI18next.init(initOptions);
    return sharedI18next;
}
//# sourceMappingURL=i18n.js.map